// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Alert, Button, Group, Modal, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { JSX } from 'react';

interface AppointmentCancellationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export function AppointmentCancellationModal({
  opened,
  onClose,
  onConfirm,
  loading = false,
}: AppointmentCancellationModalProps): JSX.Element {
  return (
    <Modal opened={opened} onClose={onClose} centered title="Cancel appointment?" size="md" padding="xl" radius="md">
      <Stack gap="lg">
        <Alert color="red" variant="light" icon={<IconAlertTriangle size={20} />}>
          Are you sure you want to cancel this appointment? This action cannot be undone.
        </Alert>
        <Group grow wrap="nowrap">
          <Button variant="default" size="md" onClick={onClose} disabled={loading} style={{ whiteSpace: 'nowrap' }}>
            No, keep
          </Button>
          <Button color="red" size="md" onClick={onConfirm} loading={loading} style={{ whiteSpace: 'nowrap' }}>
            Yes, cancel
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
